/**
 * Created by tek on 11/20/2015 AD.
 */
class Helper{
    static  arrayUnique(array) {
        var a = array.concat();
        for(var i=0; i<a.length; ++i) {
            for(var j=i+1; j<a.length; ++j) {
                if(a[i] === a[j])
                    a.splice(j--, 1);
            }
        }

        return a;
    }
    static guid() {
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        }
        return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
            s4() + '-' + s4() + s4() + s4();
    }
    static has(attr){
        return (typeof attr !== typeof undefined && attr != null && attr !== false && attr.length > 0);
    }
    static is_notnull(attr){
        return (typeof attr !== typeof undefined && attr != null);
    }
    static is_array(arrayData){
       return ( arrayData instanceof Array);
    }
    static getScope($this){
        return $($this).closest('[data-scope]');
    }

    static setOverflowScroll(selector_child){
        $('div:has(table'+selector_child+'):last').css('overflow','scroll');
    }

    static addItemToContainer(template,container,$this){
        let scope = Helper.getScope($this);
        if( Helper.has(scope) ){
            let container_select  = scope.find(container);
            let html='';
            if($(container_select).find(template).size()==0) html = $(template).html();
            else html = $(container_select).find(template).html();
            container_select.append(html);
            container_select.find('select').each(function(i,e){$(e).select2Build();});
            container_select.find('.datepicker').each(function(i,e){$(e).myDatePicker();});
        }else{
            let html = $(template).html();
            html = html.replace(/#template#/g,'t'+(new Date).getTime());
            $(container).append(html);
            $(container).find('select').each(function(i,e){$(e).select2Build();});
            $(container).find('.datepicker').each(function(i,e){$(e).myDatePicker();});

        }

        return false;
    }
    static onSelectAndShowItem(selectors = []){
        selectors.forEach((selector) =>{
            $(selector+'').on('change',(event)=>{
                let eventTarget = $(event.currentTarget);
                let showSelector = $("option:selected", eventTarget);
                eventTarget.find('option').each((index,val)=>{
                    let hideSelect = $(val).attr('data-select-show');
                    if(Helper.has(hideSelect)){
                        $(hideSelect).addClass('hide');
                    }
                });
                let updateSelector = showSelector.attr('data-select-show');
                if(Helper.has(updateSelector)){
                    $(updateSelector).removeClass('hide');
                }
            });
        });
    }
    static removeItem($this){
        let scope = Helper.getScope($this);
        MessageBox.confirm('ท่านต้องการที่จะลบรายการนี้ใช่หรือไม่',function(){
            $(scope).remove();
        });
        return false;
    }

    static editContent($uri,callback)
    {
        Helper.ajax($uri,'GET','',callback);
    }
    static deleteContent($uri,callback)
    {
        Helper.ajax($uri,'DELETE','',callback);
    }

    static showModal(html)
    {
        let contener_edit = $('#modal-edit-content');
        $('.modal-backdrop').remove();
        contener_edit.empty().append(html);
        contener_edit.find('.modal').each(function(i,e)
        {
            $(e).attr('data-backdrop','static');
            $(e).attr('data-keyboard','false');
        });
        contener_edit.find('form').each(function(i,e)
        {
            $(e).myForm();
        });
        contener_edit.find('input.datepicker').each(function(i,e)
        {
            $(e).myDatePicker();
        });
        contener_edit.find('input.datepicker-input').each(function (i, e) {
            $(e).myDatePickerAlowInput();
        });

        contener_edit.find('select').each(function(i,e)
        {
            $(e).select2Build();
        });
        contener_edit.find('.modal').modal('show');
    }

    static ajax(url,method,params,callback)
    {
        MessageBox.loading('open');
        if(typeof params==='object')
        {
            if(method!='GET') params['_method']=method;
        }
        else
        {
            if(method!='GET')
            {
                if(typeof params=='string' && params!='')
                {
                    params = params+'&_method='+method;
                }
                else
                {
                    params = {};
                    params['_method']=method;
                }
            }
        }
        $.ajax({
            url:url,
            type:method,
            dataType:'json',
            data:params,
            cache: false,
            statusCode: {
                503: function (data)
                {
                    MessageBox.loading('hide');
                    MessageBox.error('<p style="color:red">ขออภัยค่ะ ท่านไม่มีสิทธิในการเข้าใช้งาน กรุณาติดต่อเจ้าหน้าที่</p>',function(){
                        window.location.reload(true);
                    });
                },
                500: function (data)
                {
                    MessageBox.loading('hide');
                    MessageBox.error('<p style="color:red">ขออภัยค่ะ เกิดความผิดพลาด กรุณาติดต่อเจ้าหน้าที่</p>');
                },
                401: function (data)
                {
                    MessageBox.loading('hide');
                    MessageBox.error('<p style="color:red">ขออภัยค่ะ กรุณาล็อกอินเข้าสู่ระบบก่อนค่ะ</p>',function(){
                        window.location.reload(true);
                    });
                },
                422: function (data)
                {
                    MessageBox.loading('hide');
                    if(data.responseJSON.length>1)
                    {
                        var message = '<div style="text-align:left;"><ul style="list-style:none;margin:0;padding:0;">';
                        $.each(data.responseJSON, function (i, item) {
                            message += '<li style="font-size:13px;"><i style="color:red;" class="fa fa-caret-right"></i> ' + item + '</li>';
                        });
                        message += '</ul></div>';
                    }
                    else
                    {
                        var message = '';
                        $.each(data.responseJSON, function (i, item) {
                            message +=item + '<br/>';
                        });
                    }
                    MessageBox.error(message);
                }
            },
            success:function(response)
            {
                MessageBox.loading('hide');
                if(typeof response.export!=='undefined')
                {
                    if(response.export=='export-file')
                    {
                        var fm = '<form action="'+response.url+'" method="get" id="download_export_file"><input value="' + response.path + '" type="hidden" name="path"/><input value="' + response.name + '" type="hidden" name="name"/><input type="submit" id="downloadfilesubmit"/></form>';
                    }
                    else
                    {
                        var fm = '<form action="/export" method="get" id="download_export_file"><input value="' + response.file_name + '" type="hidden" name="p"/><input type="submit" id="downloadfilesubmit"/></form>';
                    }
                    $('body').append(fm);
                    $('#downloadfilesubmit').get(0).click();
                    $('#download_export_file').remove();
                    return false;
                }
                else if(typeof response.preview!=='undefined')
                {
                    var fm='<form action="/preview-file" method="get" id="download_export_file"><input value="'+response.file_name+'" type="hidden" name="f"/><input type="submit" id="downloadfilesubmit"/></form>';
                    $('body').append(fm);
                    $('#downloadfilesubmit').get(0).click();
                    $('#download_export_file').remove();
                    return false;
                }
                callback(response);
            },
            error:function(response)
            {
                MessageBox.loading('hide');
                if (typeof(response.responseJSON)==='object')
                {
                    var msg = response.responseJSON;
                    var html_msg = '';
                    $.each(msg,function(i,item){
                        html_msg += '<p class="text-danger">'+item+'</p>';
                    });
                    MessageBox.error(html_msg);
                }
                else
                {
                    MessageBox.error('เกิดความผิดพลาด กรุณาติดต่อเจ้าหน้าที่');
                }
            }
        });
    }
}
